import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lightning, SignOut, User, MusicNotes } from "@phosphor-icons/react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const linkBase =
    "text-xs tracking-[0.2em] uppercase text-ink-mute hover:text-white transition-colors";
  const linkActive = "text-brand-red neon-red";

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative w-9 h-9 border border-brand-red bg-bg-surface flex items-center justify-center clip-tag">
            <Lightning size={18} weight="fill" className="text-brand-red animate-flicker" />
            <span className="absolute inset-0 border border-brand-red opacity-40 group-hover:animate-glitch" />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-[15px] tracking-tight">
              BEAT-LAB <span className="text-brand-red">/</span> THE 808
            </div>
            <div className="text-[9px] tracking-[0.3em] text-ink-dim mt-0.5">UNDERGROUND PRODUCER OS</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-home">
            HOME
          </NavLink>
          <NavLink to="/plugin" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-plugin">
            PLUGIN
          </NavLink>
          <NavLink to="/playground" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-playground">
            PLAYGROUND
          </NavLink>
          <NavLink to="/download" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-download">
            DOWNLOAD
          </NavLink>
          <NavLink to="/pricing" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-pricing">
            PRICING
          </NavLink>
          {user && (
            <NavLink to="/dashboard" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`} data-testid="nav-dashboard">
              STUDIO
            </NavLink>
          )}
          {user?.is_admin && (
            <NavLink to="/admin" className={({ isActive }) => `${linkBase} ${isActive ? "text-brand-red neon-red" : ""}`} data-testid="nav-admin">
              ADMIN
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 border border-zinc-800 bg-bg-surface" data-testid="nav-user-chip">
                <User size={12} weight="bold" className="text-brand-red" />
                <span className="text-[10px] tracking-[0.2em] uppercase">{user.producer_name}</span>
                {user.tier && (
                  <span className="ml-1 text-[9px] tracking-[0.25em] uppercase text-brand-red border-l border-zinc-800 pl-2">
                    {user.tier}
                  </span>
                )}
              </div>
              <button
                onClick={() => { logout(); navigate("/"); }}
                data-testid="nav-logout-btn"
                className="text-xs tracking-[0.2em] uppercase text-ink-mute hover:text-brand-red transition-colors flex items-center gap-1.5"
              >
                <SignOut size={14} weight="bold" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/auth?mode=login"
                data-testid="nav-login-btn"
                className="text-xs tracking-[0.2em] uppercase text-ink-mute hover:text-white"
              >
                LOG IN
              </Link>
              <Link
                to="/auth?mode=signup"
                data-testid="nav-signup-btn"
                className="bg-brand-red text-black text-[11px] font-bold tracking-[0.2em] uppercase px-4 py-2 hover:bg-white transition-colors flex items-center gap-1.5 btn-glitch clip-arrow-r"
              >
                <MusicNotes size={14} weight="fill" /> Get Access
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
